import { render, staticRenderFns } from "./addchildamazon.vue?vue&type=template&id=f58ddb32&scoped=true"
import script from "./addchildamazon.vue?vue&type=script&lang=js"
export * from "./addchildamazon.vue?vue&type=script&lang=js"
import style0 from "./addchildamazon.vue?vue&type=style&index=0&id=f58ddb32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58ddb32",
  null
  
)

export default component.exports